import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
import placeholderImage from "../../assets/PlaceholderSvg.svg";
export var PlaceholderContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-image: url(", ");\n  background-position: ", "%;\n"], ["\n  background-image: url(", ");\n  background-position: ", "%;\n"])), placeholderImage, Math.floor(Math.random() * 100));
var templateObject_1;
//# sourceMappingURL=styles.js.map